import React from "react";
import { Button, Layout, Select, Tag } from "antd";
import {
  DisconnectOutlined,
  MenuOutlined,
  WifiOutlined,
} from "@ant-design/icons";
import ThemeChanger from "../../components/ThemeChanger";
import LangChanger from "../../components/LangChanger";
import Notifications from "../../components/Notifications";
import AvatarMenu from "../../components/AvatarMenu";
import { useLang } from "../../hooks/useLang";
import { useSelector } from "dva";
import useNetworkStatus from "../../hooks/useNetworkStatus";

const { Header: AntdHeader } = Layout;
const { Option } = Select;

function Header({ toggleCollapsed, shopLoading, shops, changeShop, shopId }) {
  const [lang] = useLang();

  const selectedShop = shops?.find((shop) => shop?.id === shopId);

  const user = useSelector((state) => state.auth.user);

  const { isOnline } = useNetworkStatus();

  return (
    <AntdHeader
      className="app-header"
      style={{
        display: "flex",
        flexWrap: "wrap",
        alignItems: "center",
        justifyContent: "space-between",
        background: "unset",
      }}
    >
      <div
        className="header-inner"
        style={{
          display: "flex",
          justifyContent: "flex-end",
          width: "100%",
          alignItems: "center",
          gap: 12,
        }}
      >
        <Tag
          icon={isOnline ? <WifiOutlined /> : <DisconnectOutlined />}
          color={isOnline ? "success" : "error"}
          style={{
            display: "inline-flex",
            alignItems: "center",
            padding: "2px 8px",
            fontSize: 12,
            borderRadius: 4,
          }}
        >
          {isOnline ? "Online" : "Offline"}
        </Tag>
        {(user?.role === "shop-owner" || user?.role === "shop-admin") && (
          <Select
            className="branch-select"
            placeholder={lang("Select Shop")}
            size="middle"
            loading={shopLoading}
            value={selectedShop ? selectedShop.id : undefined}
            dropdownMatchSelectWidth={false}
            dropdownStyle={{ minWidth: 200 }}
            onSelect={(value) => {
              changeShop(value);
            }}
          >
            {shops?.map((shop) => (
              <Option key={shop?.id} value={shop?.id}>
                {shop?.name}
              </Option>
            ))}
          </Select>
        )}
        <LangChanger />
        <ThemeChanger />
        <Notifications />
        <AvatarMenu />
        {/* Hamburger for mobile - right side */}
        <Button
          onClick={toggleCollapsed}
          style={{
            display: "inline-flex",
            alignItems: "center",
            background: "none",
            border: "none",
            fontSize: 24,
            cursor: "pointer",
            color: "#333",
          }}
          className="show-on-xs"
          aria-label="Open sidebar"
        >
          <MenuOutlined />
        </Button>
      </div>
    </AntdHeader>
  );
}

export default Header;
